export enum AppRoutes {
  Home = '/',
  NotAuthorized = '/not-authorized',
  SkinnyBanner = '/skinny-banner',
  Plp = '/plp',
}
